// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skeletonTextClassName___XKSW {
  height: 24px;
}

.translateSourceDataRow__xzwvI {
  border-bottom: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-secondary-row-sub-title-surface);
}
.translateSourceDataRow__xzwvI .fieldName__qgH8x {
  text-transform: capitalize;
  padding-left: 36px;
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}
.translateSourceDataRow__xzwvI .originalName__ZQXGI {
  text-transform: none;
  color: var(--tables-primary-row-text-main);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 14px;
}

@media (max-width: 1440px) {
  .rowWithTranslation__RS1mx .fieldName__qgH8x {
    max-width: 150px;
  }
  .rowWithTranslation__RS1mx .originalName__ZQXGI {
    max-width: 200px;
  }
}
@media (max-width: 1024px) {
  .rowWithTranslation__RS1mx .fieldName__qgH8x {
    padding-left: 26px;
  }
  .rowWithTranslation__RS1mx .originalName__ZQXGI {
    max-width: 150px;
  }
}

tr.emptyRow__IPD9y {
  display: table-row;
  height: unset;
  border-bottom: 1px solid var(--tables-primary-row-stroke);
}
tr.emptyRow__IPD9y td {
  display: table-cell;
  text-transform: none;
}`, "",{"version":3,"sources":["webpack://./../src/pages/ManageTranslations/components/TranslationsItem/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;AAzEF;;AA4EA;EACE,yDAAA;EACA,yDAAA;AAzEF;AA2EE;EACE,0BAAA;EACA,kBAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAzEJ;AA4EE;EACE,oBAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA1EJ;;AA+EE;EACE;IACE,gBAAA;EA5EJ;EA+EE;IACE,gBAAA;EA7EJ;AACF;AAgFE;EACE;IACE,kBAAA;EA9EJ;EAiFE;IACE,gBAAA;EA/EJ;AACF;;AAmFA;EACE,kBAAA;EACA,aAAA;EACA,yDAAA;AAhFF;AAkFE;EACE,mBAAA;EACA,oBAAA;AAhFJ","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.skeletonTextClassName {\n  height: 24px;\n}\n\n.translateSourceDataRow {\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-secondary-row-sub-title-surface);\n\n  .fieldName {\n    text-transform: capitalize;\n    padding-left: 36px;\n    color: var(--tables-primary-row-text-main);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n  }\n\n  .originalName {\n    text-transform: none;\n    color: var(--tables-primary-row-text-main);\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 14px;\n  }\n}\n\n.rowWithTranslation {\n  @media (max-width: 1440px) {\n    .fieldName {\n      max-width: 150px;\n    }\n\n    .originalName {\n      max-width: 200px;\n    }\n  }\n\n  @media (max-width: 1024px) {\n    .fieldName {\n      padding-left: 26px;\n    }\n\n    .originalName {\n      max-width: 150px;\n    }\n  }\n}\n\ntr.emptyRow {\n  display: table-row;\n  height: unset;\n  border-bottom: 1px solid var(--tables-primary-row-stroke);\n\n  td {\n    display: table-cell;\n    text-transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"skeletonTextClassName": `skeletonTextClassName___XKSW`,
	"translateSourceDataRow": `translateSourceDataRow__xzwvI`,
	"fieldName": `fieldName__qgH8x`,
	"originalName": `originalName__ZQXGI`,
	"rowWithTranslation": `rowWithTranslation__RS1mx`,
	"emptyRow": `emptyRow__IPD9y`
};
module.exports = ___CSS_LOADER_EXPORT___;
